module.exports = __webpack_public_path__ + "media/images/arrow-right-button-dark-ea88c712b245ae5e5048f43bcb383695.svg";